import { AnyAction } from 'redux';
import { CLEAR_REFERRAL_FILTERS, SET_REFERRAL_FILTERS } from '../actions';
import { ISelectOption as IToggleSelectOption } from '../components/SelectMultipleFilter';

export interface IReferralFilters {
  sources: Array<IToggleSelectOption>;
}

export interface IFiltersState {
  referralFilters: IReferralFilters;
}

const initialState = {
  referralFilters: {
    sources: [],
  },
};

function filtersReducer(state: IFiltersState | undefined, action: AnyAction): IFiltersState {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case SET_REFERRAL_FILTERS:
      return {
        ...state,
        referralFilters: {
          ...action.payload.filters,
        },
      };
    case CLEAR_REFERRAL_FILTERS:
      return {
        ...state,
        referralFilters: {
          ...initialState.referralFilters,
          sources: state.referralFilters.sources.map((option) => {
            return {
              ...option,
              enabled: false,
            };
          }),
        },
      };

    default:
      return state;
  }
}

export default filtersReducer;
